import React, { useState, useRef, useEffect, useCallback } from 'react';
import TicketPrices from '../TicketPrices';
import PurchaseButton from '../PurchaseButton';
import PurchaseForm from '../PurchaseForm';
import Modal from '../Modal';
import { loadTicketState, saveTicketState } from '../../utils/ticketStorage';

export default function TicketInfoBlock({ data, blockId }) {
  if (!data) {
    return (
      <p className="ticket-app__error" role="alert">
        Unable to load ticket information.
      </p>
    );
  }

  const eventId = data.event_id;
  const stored = eventId ? loadTicketState(eventId) : null;
  const [showPurchaseForm, setShowPurchaseForm] = useState(stored?.showModal ?? false);
  const formStateRef = useRef({ isForYou: stored?.isForYou ?? 0, tickets: stored?.tickets ?? [] });

  const handleFormStateChange = useCallback((state) => {
    formStateRef.current = state;
    if (eventId) saveTicketState(eventId, { ...state, showModal: showPurchaseForm });
  }, [eventId, showPurchaseForm]);

  const handleCloseModal = useCallback(() => {
    if (eventId) saveTicketState(eventId, { ...formStateRef.current, showModal: false });
    setShowPurchaseForm(false);
  }, [eventId]);

  useEffect(() => {
    if (!eventId || !showPurchaseForm) return;
    const onVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        saveTicketState(eventId, { ...formStateRef.current, showModal: true });
      }
    };
    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => document.removeEventListener('visibilitychange', onVisibilityChange);
  }, [eventId, showPurchaseForm]);

  if (!data.show_ticket_box) return null;

  const {
    prices,
    has_ticket_prices,
    sidebar_content,
    custom_registration_button,
    user,
    is_free_event,
    is_members_only,
    is_ymc_only,
  } = data;

  return (
    <>
      <TicketPrices
        data={data}
        prices={prices}
        has_ticket_prices={has_ticket_prices}
        is_ymc_only={is_ymc_only}
        is_members_only={is_members_only}
        is_free_event={is_free_event}
        user={user}
      />
      <PurchaseButton
        data={data}
        user={user}
        is_free_event={is_free_event}
        has_ticket_prices={has_ticket_prices}
        is_members_only={is_members_only}
        is_ymc_only={is_ymc_only}
        custom_registration_button={custom_registration_button}
        onShowPurchaseForm={() => setShowPurchaseForm(true)}
      />
      {sidebar_content && (
        <div
          className="ticket-info-block__sidebar"
          dangerouslySetInnerHTML={{ __html: sidebar_content }}
        />
      )}

      <Modal
        open={showPurchaseForm}
        data={data}
        onClose={handleCloseModal}
      >
        <PurchaseForm
          data={data}
          initialFormState={stored}
          onFormStateChange={handleFormStateChange}
        />
      </Modal>
    </>
  );
}
